import { useEffect } from "react";
import { Link } from "react-router-dom";
import { KONTAKT_EMAIL, SIDLO, PONUKA_ZDARMA } from "../LandingPage/sections/LandingHead";
import "./PrePrevadzkyPage.scss";

/**
 * Informacie pre majitela prevadzky, ktory zvazuje Rozvozy (rozvozy.sk/pre-prevadzky).
 *
 * PRECO SAMOSTATNE: VOP su podmienky pre STRAVNIKOV konkretnej prevadzky
 * (kto predava jedlo, reklamacie, storno). Na predajnej stranke ich citatel
 * -- majitel -- nevedel, co z toho plati pre neho. Toto nie su zmluvne
 * podmienky, len zrozumitelny popis sluzby.
 *
 * Zamerne tu nie je nic o ukonceni, exporte ani uchovani dat (rozhodnutie
 * Mata 2026-10-16) -- to sa riesi individualne. Nedopisovat bez dohody.
 */
const ICO = "31665462";

function PrePrevadzkyPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  const mail = <a href={`mailto:${KONTAKT_EMAIL}`}>{KONTAKT_EMAIL}</a>;

  return (
    <main className="pre-prevadzky">
      <div className="pre-prevadzky__container">
        <h1 className="pre-prevadzky__title">Rozvozy pre prevádzky</h1>
        <p className="pre-prevadzky__perex">
          Pre majiteľov reštaurácií a jedální, ktorí zvažujú Rozvozy. Kto systém poskytuje, čo
          dostanete a na koho sa obrátiť.
        </p>

        <section className="pre-prevadzky__section">
          <h2>Kto Rozvozy poskytuje</h2>
          <p>
            INVER spol. s r.o., {SIDLO.ulica}, {SIDLO.psc} {SIDLO.mesto}, IČO: {ICO}. E-mail: {mail}.
          </p>
        </section>

        <section className="pre-prevadzky__section">
          <h2>Čo dostanete</h2>
          <ul>
            <li>Vlastnú stránku prevádzky s vaším názvom, logom a denným menu na adrese rozvozy.sk/vasa-prevadzka. Na želanie aj na vašej doméne.</li>
            <li>Účty pre obsluhu a vodičov. Každý vidí len to, čo pri svojej práci potrebuje.</li>
            <li>Objednávky, trasy, zápis platieb a prehľad tržieb a dlhov na jednom mieste.</li>
            <li>Všetko beží v prehliadači na počítači, tablete aj mobile. Nič sa neinštaluje.</li>
          </ul>
        </section>

        <section className="pre-prevadzky__section">
          <h2>Ako začať a koľko to stojí</h2>
          <p>
            Na <Link to="/">úvodnej stránke</Link> vyplníte krátky formulár. Buď si vyžiadate demo
            s ukážkovými dátami, alebo rovno ostrú prevádzku. Každú žiadosť schvaľujeme osobne
            a prístup vám príde e-mailom.
          </p>
          <p>{PONUKA_ZDARMA}</p>
        </section>

        <section className="pre-prevadzky__section">
          <h2>Vy a vaši stravníci</h2>
          <p>
            Jedlo predávate vy. Keď si stravník objedná, uzatvára zmluvu s vašou prevádzkou, nie s Inverom.
            Inver vám dodáva len softvér.
          </p>
          <p>
            Pre stravníkov sú preto samostatné obchodné podmienky pre stravníkov. Nájdu ich na stránke
            vašej prevádzky a sú v nich vaše údaje predávajúceho, ktoré vyplníte v nastaveniach
            prevádzky.
          </p>
          <p>
            Údaje každej prevádzky sú oddelené od ostatných. Ako spracúvame osobné údaje, nájdete
            v <Link to="/ochrana-osobnych-udajov">Zásadách ochrany osobných údajov</Link>.
          </p>
        </section>

        <section className="pre-prevadzky__section">
          <h2>Podpora</h2>
          <p>
            Píšte na {mail}. Keď ste v systéme prihlásení, chybu nahlásite aj priamo tlačidlom
            Nahlásiť chybu. Pošle nám aj snímku obrazovky, takže hneď vidíme, o čo ide.
          </p>
        </section>
      </div>
    </main>
  );
}

export default PrePrevadzkyPage;
